import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const FilesFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.00139H2.87083C2.75485 0.995149 2.63871 1.01099 2.53007 1.04786C2.42144 1.08474 2.32278 1.1418 2.24062 1.2153C2.15846 1.28879 2.09466 1.37703 2.05344 1.47421C2.01222 1.57138 1.99451 1.67527 2.00148 1.77902V14.2211C1.99451 14.3249 2.01222 14.4287 2.05344 14.5259C2.09466 14.6231 2.15846 14.7113 2.24062 14.7848C2.32278 14.8583 2.42144 14.9154 2.53007 14.9523C2.63871 14.9891 2.75485 15.005 2.87083 14.9987H13.1292C13.2452 15.005 13.3613 14.9891 13.4699 14.9523C13.5786 14.9154 13.6772 14.8583 13.7594 14.7848C13.8415 14.7113 13.9053 14.6231 13.9466 14.5259C13.9878 14.4287 14.0055 14.3249 13.9985 14.2211V6H8V1.00139ZM7.00001 5.00001H4.00001V6.00001H7.00001V5.00001ZM12 7.00001H4.00001V8.00001H12V7.00001ZM12 9.00001H4.00001V10H12V9.00001ZM12 11H4.00001V12H12V11Z"
                fill={props.color}
            />
            <Path d="M13.9984 5H9V1.00139L13.9984 5Z" fill={props.color} />
        </Svg>
    );
};

export default React.memo(FilesFilled);
